import React, { Component } from "react";
import { Link } from "react-router-dom";
import TableWrapper from "../elements/TableWrapper";
import { Layout, message, Row, Col, Modal } from "antd";
import MiCompAPI from "../../util/api";

import img from "../../assets/img/At the office-pana 1.png";

import AddRequestTemplate from "./AddRequestTemplate";
import moment from "moment";
const { Content } = Layout;
const { confirm } = Modal;
class ServiceRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allrequest: true,
      id: undefined,
      data: [],
      request: [],
      allFields: true,
      addRequest: false,
      addservicerequest: false,
      currentStatus: true,
      isLoading: this.props.isLoading,
    };
    const { decodedToken } = this.props.userPermandMasters;
    var role = decodedToken.UserRoleName;
    if (role === "member") {
      this.columnsdata = [
        {
          title: "Request Id",
          dataIndex: "srNumber",
          render: (text, record) => {
            return (
              <Link
                to={{
                  pathname: "/requestView",
                  state: record.srId,
                  // name: record.templateName,
                }}
              >
                <Row>
                  <Col>
                    {text} 
                    {/* <span style={{ color: "black" }}> */}
                      {/* {record.templateName} */}
                    {/* </span> */}
                  </Col>
                </Row>
              </Link>
            );
          },
          // sorter: (a, b) => a.srId.localeCompare(b.srId),
          // sortDirections: ["descend", "ascend"],
        },
        {
          title: " Event Name",
          dataIndex: "eventName",

          // sorter: (a, b) => a.eventName.localeCompare(b.eventName),
          // sortDirections: ["descend", "ascend"],
        },
        {
          title: " Assigned To",
          dataIndex: "brokerName",

          sorter: (a, b) => a.brokerName.localeCompare(b.brokerName),
          sortDirections: ["descend", "ascend"],
        },

        {
          title: "Requested Date",
          dataIndex: "requestedDate",
          sorter: (a, b) =>
            new Date(a.requestedDate) - new Date(b.requestedDate),
          render: (text, record) =>
            record["requestedDate"] !== null && record["requestedDate"] !== ""
              ? moment(record["requestedDate"]).format("MM/DD/YYYY")
              : "",
          sortDirections: ["descend", "ascend"],
        },

        {
          title: "Status",
          dataIndex: "currentStatus",
          sorter: (a, b) => a.currentStatus.localeCompare(b.currentStatus),
          sortDirections: ["descend", "ascend"],
        },

        {
          title: "Actions",
          render: (text, record) => {
            return (
              <div style={{ display: "flex", width: 20 }}>
                <>
                  <i
                    className="fa fa-eye fa-b"
                    aria-hidden="true"
                    onClick={() => {
                      this.props.history.push({
                        pathname: "/requestView",
                        state: record.srId,
                        name: record.templateName,
                      });
                    }}
                  ></i>
                  {record["currentStatus"] === "Open" && (
                    <i
                      onClick={() =>
                        this.CancelServiceRequest({
                          srId: record["srId"],
                          currentStatus: record["currentStatus"],
                          nextStatus: "terminated",
                        })
                      }
                      className="fa fa-times fa-b "
                      aria-hidden="true"
                    ></i>
                  )}
                </>
              </div>
            );
          },
        },
      ];
    }
    if (role === "carrier") {
      this.columnsdata = [
        {
          title: "Request Id",
          dataIndex: "srNumber",
          render: (text, record) => {
            return (
              <Link
                to={{
                  pathname: "/requestView",
                  state: record.srId,
                  // name: record.templateName,
                }}
              >
                <Row>
                  <Col>
                    {text} 
                    {/* <span style={{ color: "black" }}>
                      {record.templateName}
                    </span> */}
                  </Col>
                </Row>
              </Link>
            );
          },
          // sorter: (a, b) => a.srNumber.localeCompare(b.srNumber),
          // sortDirections: ["descend", "ascend"],
        },
        {
          title: " Event Name",
          dataIndex: "eventName",

          // sorter: (a, b) => a.eventName.localeCompare(b.eventName),
          // sortDirections: ["descend", "ascend"],
        },
        {
          title: " Requested By",
          dataIndex: "requestedByName",

          sorter: (a, b) => a.requestedByName.localeCompare(b.requestedByName),
          sortDirections: ["descend", "ascend"],
        },
        {
          title: " Broker ",
          dataIndex: "brokerName",

          sorter: (a, b) => a.brokerName.localeCompare(b.brokerName),
          sortDirections: ["descend", "ascend"],
        },
        {
          title: "Requested Date",
          dataIndex: "requestedDate",
          sorter: (a, b) =>
            new Date(a.requestedDate) - new Date(b.requestedDate),
          render: (text, record) =>
            record["requestedDate"] !== null && record["requestedDate"] !== ""
              ? moment(record["requestedDate"]).format("MM/DD/YYYY")
              : "",
          sortDirections: ["descend", "ascend"],
        },

        {
          title: "Status",
          dataIndex: "currentStatus",

          sorter: (a, b) => a.currentStatus.localeCompare(b.currentStatus),
          sortDirections: ["descend", "ascend"],
        },
      ];
    }
    if (role === "broker") {
      this.columnsdata = [
        {
          title: "Request Id",
          dataIndex: "srNumber",
          render: (text, record) => {
            return (
              <Link
                to={{
                  pathname: "/requestView",
                  state: record.srId,
                  // name: record.templateName,
                }}
              >
                <Row>
                  <Col>
                    {text} 
                    {/* <span style={{ color: "black" }}>
                      {record.templateName}
                    </span> */}
                  </Col>
                </Row>
              </Link>
            );
          },
          // sorter: (a, b) => a.srId.localeCompare(b.srId),
          // sortDirections: ["descend", "ascend"],
        },
        {
          title: " Event Name",
          dataIndex: "eventName",

          // sorter: (a, b) => a.eventName.localeCompare(b.eventName),
          // sortDirections: ["descend", "ascend"],
        },
        {
          title: " Requested By",
          dataIndex: "requestedByName",

          sorter: (a, b) => a.requestedByName.localeCompare(b.requestedByName),
          sortDirections: ["descend", "ascend"],
        },
        {
          title: "Requested Date",
          dataIndex: "requestedDate",
          sorter: (a, b) =>
            new Date(a.requestedDate) - new Date(b.requestedDate),
          render: (text, record) =>
            record["requestedDate"] !== null && record["requestedDate"] !== ""
              ? moment(record["requestedDate"]).format("MM/DD/YYYY")
              : "",
          sortDirections: ["descend", "ascend"],
        },
        {
          title: " Assigned to Carrier ",
          dataIndex: "carrierName",

          // sorter: (a, b) => a.carrierName.localeCompare(b.carrierName),
          sortDirections: ["descend", "ascend"],
        },
        {
          title: "Status",
          dataIndex: "currentStatus",

          sorter: (a, b) => a.currentStatus.localeCompare(b.currentStatus),
          sortDirections: ["descend", "ascend"],
        },
      ];
    }

    this.api = new MiCompAPI(this.props.userPermandMasters);

    this.tableButtons = [];
    if (role === "member")
      this.tableButtons.push({
        buttonType: "primary",
        content: "Add Request",
        clickHandler: () => {
          this.setState({ addRequest: true });
        },
      });
  }

  componentDidMount() {
    this.GetAllServiceRequestByUserId();
  }

  CancelServiceRequest = (data) => {
    confirm({
      title: "Do you want to cancel the Request?",
      onOk: () => {
        this.api.invoke(
          "ChangeServiceRequestStatus",
          "patch",
          (data, success) => {
            if (success) {
              if (data.statusCode === 200) {
                message.destroy();
                message.success(data.statusMessage, 3);

                this.GetAllServiceRequestByUserId();
              } else {
                message.destroy();
                message.error(data.statusMessage, 3);
              }
            }
          },
          data
        );
      },

      okText: "Yes",
      cancelText: "No",
      onCancel() {},
    });
  };
  GetAllServiceRequestByUserId() {
    this.api.invoke("GetAllServiceRequestByUserId", "get", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          const field = data.data;
          this.data = field;
          this.setState({ allrequest: false });
        } else {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
      }
    });
  }

  UserDefaultHandler = () => {
    this.setState({ addRequest: false });
  };

  render() {
    return (
      <Content>
        {this.state.addRequest ? (
          <Modal visible={this.state.addRequest}>
            <AddRequestTemplate
              userPermandMasters={this.props.userPermandMasters}
              closeDrawerHandler={this.UserDefaultHandler}
              submitHandler={() => {
                this.UserDefaultHandler();
                this.GetAllServiceRequestByUserId();
              }}
              width="500"
            />
          </Modal>
        ) : null}
        <div className="mi_main_div" style={{ padding: "40px" }}>
          <div className="mi_box">
            <Row span={24}>
              <Col span={18}>
                <h4 className="mi_box_h4"> Service Requests</h4>
              </Col>
              <Col span={6}>
                <img
                  alt="example"
                  style={{ height: "182px", marginTop: "-80px" }}
                  src={img}
                />
              </Col>
            </Row>
          </div>
          <div style={{ marginRight: "2px", marginLeft: "2px" }}>
            <TableWrapper
              rowKey="srId"
              columns={this.columnsdata}
              data={this.state.allrequest ? null : this.data}
              // loading={this.state.allrequest}
              buttons={this.tableButtons}
              title=" Service Requests"
              search={true}
            />
          </div>
        </div>
      </Content>
    );
  }
}

export default ServiceRequest;
